import React from 'react';

const AccessDenied = () => {
  return <p>Access denied</p>;
};

export default AccessDenied;
